export const iconFiles = [
  'activity',
  'alert',
  'alert-circle',
  'alert-triangle',
  'anchor',
  'announcement-01',
  'archive',
  'arrow-block-down',
  'arrow-block-left',
  'arrow-block-right',
  'arrow-block-up',
  'arrow-circle-broken-down',
  'arrow-circle-broken-down-left',
  'arrow-circle-broken-down-right',
  'arrow-circle-broken-left',
  'arrow-circle-broken-right',
  'arrow-circle-broken-up',
  'arrow-circle-broken-up-left',
  'arrow-circle-broken-up-right',
  'arrow-circle-down',
  'arrow-circle-down-left',
  'arrow-circle-down-right',
  'arrow-circle-left',
  'arrow-circle-right',
  'arrow-circle-up',
  'arrow-circle-up-left',
  'arrow-circle-up-right',
  'arrow-down',
  'arrow-down-left',
  'arrow-down-right',
  'arrow-left',
  'arrow-narrow-down',
  'arrow-narrow-down-left',
  'arrow-narrow-down-right',
  'arrow-narrow-left',
  'arrow-narrow-right',
  'arrow-narrow-up',
  'arrow-narrow-up-left',
  'arrow-narrow-up-right',
  'arrow-right',
  'arrow-square-down',
  'arrow-square-down-left',
  'arrow-square-down-right',
  'arrow-square-left',
  'arrow-square-right',
  'arrow-square-up',
  'arrow-square-up-left',
  'arrow-square-up-right',
  'arrow-up',
  'arrow-up-left',
  'arrow-up-right',
  'arrows-down',
  'arrows-left',
  'arrows-right',
  'arrows-triangle',
  'arrows-up',
  'atom-01',
  'award-01',
  'bank',
  'bank-note-01',
  'beaker-01',
  'bell-03',
  'bell-04',
  'bell-minus',
  'bell-off-01',
  'bell-ringing-03',
  'beneficiary',
  'bible',
  'birthday-cake',
  'book-open-01',
  'boy',
  'briefcase-02',
  'building-01',
  'calendar',
  'calendar-check-01',
  'calendar-check-02',
  'calendar-date',
  'calendar-dollar',
  'calendar-heart-01',
  'calendar-heart-02',
  'calendar-minus-02',
  'calendar-plus-02',
  'camera-01',
  'car-01',
  'card-amex',
  'card-discover',
  'card-mastercard',
  'card-visa',
  'certificate-01',
  'certificate-02',
  'chart-breakout-circle',
  'check',
  'check-circle',
  'chevron-down',
  'chevron-down-double',
  'chevron-left',
  'chevron-left-double',
  'chevron-right',
  'chevron-right-double',
  'chevron-selector-horizontal',
  'chevron-selector-vertical',
  'chevron-up',
  'chevron-up-double',
  'chicken',
  'child',
  'children',
  'christ',
  'christmas-gift',
  'church',
  'circle',
  'clipboard-check',
  'clock',
  'cloud-raining-03',
  'coins-02',
  'coins-hand',
  'compass-03',
  'corner-down-left',
  'corner-down-right',
  'corner-left-down',
  'corner-left-up',
  'corner-right-down',
  'corner-right-up',
  'corner-up-left',
  'corner-up-right',
  'credit-card-02',
  'credit-card-minus',
  'credit-card-plus',
  'credit-card-x',
  'currency-bitcoin-circle',
  'currency-dollar',
  'dots-horizontal',
  'dots-vertical',
  'download-01',
  'droplets-01',
  'edit-01',
  'edit-02',
  'edit-04',
  'education',
  'expand-01',
  'expand-02',
  'expand-03',
  'expand-04',
  'expand-05',
  'expand-06',
  'eye',
  'eye-off',
  'face-content',
  'face-happy',
  'facebook',
  'family-gift',
  'fcp',
  'female',
  'file-04',
  'file-06',
  'file-07',
  'file-check-02',
  'file-download-01',
  'file-heart-01',
  'file-heart-02',
  'file-question-03',
  'filter-funnel-02',
  'financial-professional',
  'flip-backward',
  'flip-forward',
  'food',
  'gift-01',
  'girl',
  'give-stock',
  'glasses-02',
  'globe-04',
  'globe-05',
  'google',
  'graduation-hat-02',
  'grain',
  'handshake',
  'heart',
  'heart-circle',
  'heart-hand',
  'help-circle',
  'home-03',
  'hurricane-02',
  'image-03',
  'image-plus',
  'image-user',
  'image-user-check',
  'inbox-01',
  'infinity',
  'info-circle',
  'instagram',
  'intersect-square',
  'life-buoy-01',
  'lightbulb-05',
  'line-chart-up-02',
  'link-01',
  'link-broken-01',
  'link-external-01',
  'linkedin',
  'list',
  'loading-02',
  'lock-01',
  'log-in-01',
  'log-out-01',
  'luggage-03',
  'mail-01',
  'mail-04',
  'male',
  'marker-pin-01',
  'marker-pin-04',
  'maximize-01',
  'maximize-02',
  'medical',
  'medical-circle',
  'menu-01',
  'message-alert-circle',
  'message-chat-circle',
  'message-check-circle',
  'message-circle-01',
  'message-dots-circle',
  'message-heart-circle',
  'message-notification-circle',
  'message-plus-circle',
  'message-question-circle',
  'message-question-square',
  'message-smile-circle',
  'message-text-circle-01',
  'message-x-circle',
  'minimize-01',
  'minimum-distribution',
  'minus',
  'minus-circle',
  'mom-baby',
  'monitor-01',
  'move',
  'music-note-01',
  'newspaper',
  'notification-box',
  'notification-message',
  'notification-text',
  'number-1',
  'number-2',
  'number-3',
  'number-4',
  'number-5',
  'number-6',
  'number-7',
  'number-8',
  'number-9',
  'number-circled-1',
  'number-circled-2',
  'number-circled-3',
  'number-circled-4',
  'number-circled-5',
  'number-circled-6',
  'number-circled-7',
  'number-circled-8',
  'number-circled-9',
  'nurturers-baby',
  'nurturers-baby-birth-education',
  'nurturers-baby-care-item',
  'nurturers-baby-care-item-1',
  'nurturers-baby-care-item-2',
  'nurturers-baby-care-item-3',
  'nurturers-baby-nutrition',
  'nurturers-celebration',
  'nurturers-celebration-1',
  'nurturers-celebration-2',
  'nurturers-expectant-family',
  'nurturers-first-birthday',
  'nurturers-first-birthday-1',
  'nurturers-health-exams',
  'nurturers-mothers-babies',
  'nurturers-nurturers-center',
  'nurturers-nurturing-life',
  'nurturers-on-location-medical-care',
  'nurturers-pregnant-mother',
  'nurturers-prenatal-exams',
  'package',
  'pause-circle',
  'pencil',
  'pencil-line',
  'phone',
  'phone-02',
  'phone-call-01',
  'phone-hang-up',
  'phone-plus',
  'pie-chart-01',
  'pie-chart-02',
  'pie-chart-03',
  'pie-chart-04',
  'piggy-bank-01',
  'placeholder',
  'plane',
  'plant',
  'plate',
  'play',
  'play-circle',
  'pledges',
  'plus',
  'plus-circle',
  'pray',
  'radio',
  'receipt-check',
  'refresh-ccw-01',
  'refresh-ccw-02',
  'refresh-ccw-03',
  'refresh-ccw-04',
  'refresh-ccw-05',
  'refresh-cw-01',
  'refresh-cw-02',
  'refresh-cw-03',
  'refresh-cw-04',
  'refresh-cw-05',
  'region',
  'repeat-03',
  'reverse-left',
  'reverse-right',
  'rss-01',
  'ruler',
  'scales-01',
  'search-sm',
  'send-01',
  'settings-01',
  'settings-04',
  'share-02',
  'shield-01',
  'shield-plus',
  'shield-tick',
  'shopping-bag-02',
  'shopping-bag-plus',
  'signpost',
  'skippy',
  'skippy-filled',
  'star-01',
  'sun',
  'switch-horizontal-01',
  'switch-horizontal-02',
  'switch-vertical-01',
  'switch-vertical-02',
  'thumbs-down',
  'thumbs-up',
  'tiktok',
  'tool-02',
  'trash-01',
  'trend-up-01',
  'trust-bbb',
  'trust-charity-watch',
  'trust-ecfa',
  'trust-guide-star',
  'trust-seal-of-transparency-guide-star',
  'tv-03',
  'twitter',
  'upload-01',
  'user-01',
  'user-02',
  'user-03',
  'user-check-01',
  'user-check-02',
  'user-circle',
  'user-down-01',
  'user-down-02',
  'user-edit',
  'user-email',
  'user-left-01',
  'user-left-02',
  'user-minus-01',
  'user-minus-02',
  'user-plus-01',
  'user-plus-02',
  'user-right-01',
  'user-right-02',
  'user-square',
  'user-up-01',
  'user-up-02',
  'user-x-01',
  'user-x-02',
  'users-01',
  'users-02',
  'users-03',
  'users-check',
  'users-dollar',
  'users-down',
  'users-edit',
  'users-left',
  'users-minus',
  'users-plus',
  'users-right',
  'users-up',
  'users-x',
  'virus',
  'volunteer',
  'wallet-02',
  'water-faucet',
  'wheelchair',
  'x-circle',
  'x-close',
  'youtube',
] as const;
